export const environment = {
  production: true,
  backendUrl: 'http://51.83.135.160:8089/api/v1/'
};
